<template>
	<div v-if="feedbacks" :key="gkey">
		<h1>Feedbacks</h1>
		<div
			v-for="(f, index) in feedbacks"
			:key="f.key"
			style="border-bottom: 2px solid red; width: 90%; margin: 0 5%"
		>
			<p>feedback_id: {{ f.f_id }}</p>
			<p v-if="f.line">{{ f.line.fr }}</p>
			<p v-if="f.line">{{ f.line.de }}</p>
			<p v-if="f.answer">answer: {{ f.answer }}</p>

			<p>{{ f.message }}</p>
			<p>{{ to_date(f.time) }}</p>
			<button
				@click="handle(f.f_id, 'feedbacks', index)"
				style="cursor: pointer"
			>
				{{ f.handled ? "handled ✅" : "set handled" }}
			</button>
		</div>
		<h1>Reports</h1>
		<div
			v-for="(r, index) in reports"
			:key="r.key"
			style="border-bottom: 2px solid red; width: 90%; margin: 0 5%"
		>
			<p>report_id: {{ r.r_id }}</p>
			<p>{{ r.song_id }}</p>
			<p>{{ r.message }}</p>
			<p>{{ r.line.fr }}</p>
			<p>{{ r.line.de }}</p>
			<p v-if="r.answer">answer: {{ r.answer.map((el) => el.value) }}</p>
			<p>{{ to_date(r.time) }}</p>
			<button @click="handle(r.r_id, 'reports', index)">
				{{ r.handled ? "handled ✅" : "handle" }}
			</button>
		</div>
	</div>
</template>

<script>
import { db } from "../../firebase";

export default {
	data() {
		return {
			feedbacks: null,
			reports: null,
			gkey: 0,
		};
	},
	created() {
		db.collection("feedback")
			.where("handled", "==", false)
			.get()
			.then((docs) =>
				(this.feedbacks = docs.docs.map((doc) => {
					let res = doc.data();
					res.f_id = doc.id;
					return res;
				})).sort((a, b) => b.time - a.time)
			);

		db.collection("reports")
			.where("handled", "==", false)
			.get()
			.then((docs) =>
				(this.reports = docs.docs.map((doc) => {
					let res = doc.data();
					res.r_id = doc.id;
					return res;
				})).sort((a, b) => b.time - a.time)
			);
	},
	methods: {
		to_date(time) {
			const date = new Date(time);
			return date.toString().substring(4, 24);
		},
		handle(id, type, index) {
			if (type === "feedbacks") {
				const status = this.feedbacks[index].handled;
				this.feedbacks[index].handled = !status;
				db.collection("feedback")
					.doc(id)
					.update({ handled: !status });
			} else if (type === "reports") {
				const status = this.reports[index].handled;
				this.reports[index].handled = !status;
				db.collection("reports")
					.doc(id)
					.update({ handled: !status });
			}
			this.gkey++;
			return id;
		},
	},
};
</script>

<style scoped>
button {
	font-size: 20px;
	margin-bottom: 20px;
}
</style>
